import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { CircularProgress } from '@mui/joy';
import { Backdrop } from "@mui/material"

const dataProviderName = 'persons/person';
const model = 'persons/person';
const wizardName = 'Service dissociation';
const wizardObject = 'Service';
const wizardAction = 'serviceDissociation';

const ServiceDissociation = (params) => {
    const { t } = useTranslation();
    const { userCapabilities } = useContext(AppContext);

    const [drawable, setDrawable] = useState(true);
    const { doAction, item, errorMessage, errors, saving, success } = useDataProvider(dataProviderName, params.multipart);
    const [dissociated, setDissociated] = useState([])

    const handleCheckChange = (event) => {
        const checked = event.target.checked;
        const value = event.target.value;

        setDissociated((prev) => {
            if (checked) {
                return prev.includes(value) ? prev : [...prev, value];
            } else {
                return prev.filter((v) => v !== value);
            }
        });
    };

    const detailConfig = {
        "tabs": [
            {
                "name": "dissociation",
                "fieldsets": [
                    {
                        "name": "dissociation",
                        "fields": {
                            "service_assigned": {
                                "type": "sectiontitle",
                                "className": "col-12"
                            },
                            "assignment_end_at": {
                                "type": "date",
                                "className": "col-12",
                                "icon": "faCalendarXmark"
                            },
                            "dissociated": {
                                "type": "relationship",
                                "view": "service",
                                "readonly": true,
                                "checkable": true,
                                "checked": true,
                                "onCheckChange": handleCheckChange,
                                "relation": {
                                    "drawerRoutes": "services",
                                    "inverseRelation": "person",
                                    "inverseRelationType": "relationship",
                                    "relationAssociator": "hidden",
                                    "relationDissociator": "hidden"
                                }
                            },
                        }
                    }
                ]
            }
        ],
        "validation": []
    }

    const [editing, setEditing] = useState(true)

    useEffect(() => {
        if (success) {
            (async () => {
                try {
                    await params.handleClose(params.uid, item.data)
                } catch (e) { }
            })()
        }
    }, [success]);

    const handleSave = async (data) => {
        data.dissociated = dissociated;
        doAction && doAction({ action: wizardAction, model: model ? model : dataProviderName, data: data });
    }

    return (
        !drawable ? <Backdrop open={!drawable} style={{ backgroundColor: "white" }}><CircularProgress /></Backdrop> :
            <>
                <DetailComponent
                    values={{
                        "id": item?.data?._id,
                        "assignment_end_at": new Date(),
                        "dissociated": item?.data?.services.filter(service => ['active', 'future'].includes(service.status))
                    }}
                    modelName={model.split('/')[1]}
                    detailConfig={detailConfig}
                    dataProviderName={dataProviderName}
                    save={handleSave}
                    onEditing={setEditing}
                    saving={saving}
                    errors={errors}
                    errorMessage={errorMessage}
                    title={t(wizardName)}
                    canSave={userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
                    header={
                        <InfoHeader
                            view="wizard"
                            title={t(wizardName)}
                            subtitle={t('Remove a {{wizardObject}} from {{firstname}} {{lastname}}', { wizardObject: wizardObject, firstname: item?.data?.firstname, lastname: item?.data?.lastname })}
                        />
                    }
                    {...params}
                />
            </>
    )
}

export default ServiceDissociation;